export default "__VITE_ASSET__2mNZbIQG__"